import { useEffect } from 'react';
import { HttpClient } from '../api/HttpClient';

type Opts = { intervalMs?: number; enabled?: boolean; pingPath?: string };

export function useAuthHeartbeat({
  intervalMs = 15000,
  enabled = true,
  pingPath = '/ping', // zwróć 204 (OK) lub 401 (nieważny)
}: Opts = {}) {
  useEffect(() => {
    if (!enabled) return;

    let timer: number | undefined;

    const ping = async () => {
      try {
        await HttpClient.getInstance().get(pingPath, {
          headers: { 'X-Auth-Ping': '1' },
          params: { _t: Date.now() },
        });
      } catch {
        // 401 przejmie globalny interceptor i zrobi redirect
      }
    };

    ping();
    timer = window.setInterval(ping, intervalMs);

    const onFocus = () => ping();
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);

    return () => {
      if (timer) window.clearInterval(timer);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onFocus);
    };
  }, [enabled, intervalMs, pingPath]);
}